module.exports = __webpack_public_path__ + "img/home-ipad-bg_enBU.a5b7c6f.jpg";